import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer from localStorage as fallback when cookies unavailable
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export function formatCurrency(n, short = false) {
  if (n == null || n === "" || isNaN(Number(n))) return "—";
  const num = Number(n);
  if (short) {
    if (Math.abs(num) >= 1e7) return "₹" + (num / 1e7).toFixed(2) + " Cr";
    if (Math.abs(num) >= 1e5) return "₹" + (num / 1e5).toFixed(2) + " L";
    if (Math.abs(num) >= 1e3) return "₹" + (num / 1e3).toFixed(1) + " K";
  }
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function formatDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch {
    return s;
  }
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const now = new Date();
  const diff = Math.ceil((d - now) / (1000 * 60 * 60 * 24));
  return diff;
}
